<template>
  <div>
    <b-card>
      <b-carousel
        id="carousel-interval"
        controls
        indicators
        img-width="1024"
        img-height="480"
        :interval="3000"
        style="text-shadow: 1px 1px 2px #333;"
      >
        <b-carousel-slide
          v-for="(file, file_k) in app.media_files"
          :key="`media-file-${file_k}`"
        >
          <template #img>
            <img
              :src="file"
              class="d-block img-fluid w-100 carousel-image-clickable"
              alt="Media image"
              @click="openPreview(file)"
            >
          </template>
        </b-carousel-slide>
      </b-carousel>
    </b-card>

    <!-- Image Preview Modal -->
    <b-modal
      v-model="showPreview"
      size="xl"
      centered
      hide-footer
      hide-header
      modal-class="image-preview-modal"
      body-class="p-0"
    >
      <div class="preview-container position-relative">
        <!-- Close Button -->
        <button
          type="button"
          class="close-btn"
          @click="showPreview = false"
        >
          <span aria-hidden="true">&times;</span>
        </button>

        <!-- Previous Arrow -->
        <button
          v-if="app.media_files.length > 1"
          type="button"
          class="preview-arrow preview-arrow-left"
          :disabled="previewIndex === 0"
          @click="previousImage"
        >
          <span>&lsaquo;</span>
        </button>

        <!-- Image -->
        <div class="text-center">
          <img
            :src="previewImage"
            class="img-fluid"
            alt="Preview"
            style="max-height: 80vh;"
          >
        </div>

        <!-- Next Arrow -->
        <button
          v-if="app.media_files.length > 1"
          type="button"
          class="preview-arrow preview-arrow-right"
          :disabled="previewIndex === app.media_files.length - 1"
          @click="nextImage"
        >
          <span>&rsaquo;</span>
        </button>

        <!-- Image Counter -->
        <div
          v-if="app.media_files.length > 1"
          class="image-counter"
        >
          {{ previewIndex + 1 }} / {{ app.media_files.length }}
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BCarousel, BCarouselSlide, BModal,
} from 'bootstrap-vue'
import { getLocale } from '@core/utils/utils'

export default {
  components: {
    BCarouselSlide,
    BCarousel,
    BCard,
    BModal,
  },
  directives: {
  },
  props: {
    app: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showPreview: false,
      previewImage: null,
      previewIndex: 0,
    }
  },
  computed: {
    //
  },
  created() {
    //
  },
  methods: {
    getLocale,
    openPreview(imageSrc) {
      this.previewIndex = this.app.media_files.indexOf(imageSrc)
      this.previewImage = imageSrc
      this.showPreview = true
    },
    previousImage() {
      if (this.previewIndex > 0) {
        this.previewIndex--
        this.previewImage = this.app.media_files[this.previewIndex]
      }
    },
    nextImage() {
      if (this.previewIndex < this.app.media_files.length - 1) {
        this.previewIndex++
        this.previewImage = this.app.media_files[this.previewIndex]
      }
    },
  },
  setup() {
    return {
      //
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-knowledge-base.scss';
.modal-body label {
  font-size: unset;
}

// Ensure carousel controls are visible
#carousel-interval {
  .carousel-control-prev,
  .carousel-control-next {
    opacity: 0.8;
    
    &:hover {
      opacity: 1;
    }
  }

  .carousel-control-prev-icon,
  .carousel-control-next-icon {
    width: 2rem;
    height: 2rem;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    padding: 0.5rem;
  }

  .carousel-indicators {
    position: relative;
    bottom: auto;
    margin-top: 1rem;
    margin-bottom: 0;
    
    li {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.3);
      border: 1px solid rgba(0, 0, 0, 0.5);
      
      &.active {
        background-color: rgba(0, 0, 0, 0.7);
      }
    }
  }
}

// Make carousel images clickable
.carousel-image-clickable {
  cursor: pointer;
  transition: opacity 0.3s ease;
  
  &:hover {
    opacity: 0.9;
  }
}

// Image preview modal styling
.image-preview-modal {
  .modal-dialog {
    max-width: 90vw;
  }
  
  .modal-body {
    background-color: #000;
  }

  .preview-container {
    position: relative;
    min-height: 400px;
  }

  .close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1050;
    background: rgba(0, 0, 0, 0.5);
    border: none;
    color: #fff;
    font-size: 2rem;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.3s ease;

    &:hover {
      background: rgba(0, 0, 0, 0.8);
    }

    span {
      line-height: 1;
      margin-top: -3px;
    }
  }

  .preview-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1050;
    background: rgba(0, 0, 0, 0.5);
    border: none;
    color: #fff;
    font-size: 3rem;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;

    &:hover:not(:disabled) {
      background: rgba(0, 0, 0, 0.8);
      transform: translateY(-50%) scale(1.1);
    }

    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }

    span {
      line-height: 1;
      margin-top: -5px;
    }
  }

  .preview-arrow-left {
    left: 20px;
  }

  .preview-arrow-right {
    right: 20px;
  }

  .image-counter {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 0.9rem;
    font-weight: 500;
  }
}
</style>
